import { FC, ReactNode, useEffect } from 'react';

import logger from '@eneco/common/log';

import * as sparkyIcons from '../../icons';
import { CloseIcon, type IconProps } from '../../icons';

interface IconLoaderProps extends IconProps {
  iconName?: string;
  fallbackIcon?: ReactNode;
}

// Temporary mapping for icons that have been renamed or need to be aliased for backward compatibility. This allows us to maintain support for old icon names while transitioning to new ones without breaking existing implementations in Sitecore.
const ICON_NAME_MAPPINGS: Record<string, string> = {
  TwitterIcon: 'XIcon',
  YoutubeIcon: 'YouTubeIcon',
  WarmWaterIcon: 'WaterWarmIcon',
  StarIcon: 'StarFullIcon',
  StarStrokeIcon: 'StarEmptyIcon',
  BoostChargingIcon: 'ChargingBoostIcon',
  TemperaturePresetIcon: 'TemperatureIcon',
  ColdWaterIcon: 'WaterColdIcon',
  GlowIcon: 'AiSparkIcon',
  AISparkIcon: 'AiSparkIcon',
};

export const IconLoader: FC<IconLoaderProps> = ({ iconName = '', fallbackIcon, ...rest }) => {
  const iconCollection = sparkyIcons as Partial<{
    [key: string]: FC<IconProps>;
  }>;

  const mappedName = ICON_NAME_MAPPINGS[iconName] || iconName;
  const Icon = iconCollection[mappedName];

  useEffect(() => {
    if (!Icon && fallbackIcon === undefined) {
      logger.error('wVRxzv', `Icon ${iconName} could not be found. A placeholder is rendered.`);
    }
  }, [Icon, fallbackIcon, iconName]);

  if (Icon) return <Icon {...rest} />;

  if (fallbackIcon) return fallbackIcon;

  return <CloseIcon {...rest} />;
};
